export default "__VITE_ASSET__fjmZbQLx__"